import { Component, OnInit, EventEmitter, Output ,Inject,ViewChild, ElementRef ,} from '@angular/core';
import { FormBuilder, Validators, FormGroup,ValidationErrors ,AbstractControl} from '@angular/forms';
import { CreditCardValidator } from 'angular-cc-library';
import { CardPaymentService } from '../card-payment.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { FlashMessagesService } from 'angular2-flash-messages';
import { TournamentService } from 'src/app/tournamentpopup/tournament.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { UserBalanceData } from '.././../store/actions/appActions';
import { first } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MAT_DIALOG_DATA,MatDialogRef,MatDialog} from '@angular/material/dialog';
import { MainService } from '../../_services/main.service';
@Component({
  selector: 'app-first-time-deposit',
  templateUrl: './first-time-deposit.component.html',
  styleUrls: ['./first-time-deposit.component.scss']
})

export class FirstTimeDepositComponent implements OnInit {
  @ViewChild('addFundFormElement') addFundFormElement!: ElementRef;
  @Output() depositSuccess: EventEmitter<any> = new EventEmitter();
  addFundForm: FormGroup;
  fundsData: any;
  user_id: Number;
  currentUser: any;
  promo_code_value: any;
  sub_checkPromoCode: Subscription;
  submitted: boolean;
  userData: any;
  ipAddress = '192.168.0.149';
  isFormShow = false;
  promo_code_validation = { message: '', icon: 'far fa-check-circle', icon_color: '', validate: '',bonus_amount:'' };
  assetsUrl: any;
  isWelcome : any;
  welcomeDataObj : any;
  awsUploadUrl = `${environment.assetURL}/assets/default/images/`;
  isCheckingPromo = false;
  isCheckPromoDis = true;
  isDisable = false;
  minDeposit :number; 
  maxDeposit : number;
  selectedAmt = 25;
  constructor(
    @Inject(MAT_DIALOG_DATA) public welcomeData: any,
    public _cardPaymentService: CardPaymentService,
    public formBuilder: FormBuilder,
    public spinner: NgxSpinnerService,
    public _flashMessagesService: FlashMessagesService,
    public _tournamentService: TournamentService,
    public store: Store<AppState>,
    public deviceService: DeviceDetectorService,
    public dialogRef: MatDialogRef<FirstTimeDepositComponent>,
    public _mainService : MainService
  ) {
    this.store.select('authData').subscribe(state => {
      if (state[0]) {
        this.userData = state[0];
        this.user_id = this.userData.id;
      }
    });
    if(welcomeData && welcomeData.status){
      this.isWelcome = welcomeData.status;
      this.welcomeDataObj = welcomeData;
    }
  }

  get f() {
    return this.addFundForm.controls;
  }

  ngOnInit() {
    this._mainService.getSetting().subscribe(shows => {
      if (shows.status === 'success') {
        let userSettings = shows.entities;
        this.minDeposit = Number(userSettings["min_deposit"]) || 3;
        this.maxDeposit = Number(userSettings["max_deposit"]) || 1000;
      }
    }, err => {
      console.log(err);
    });
    this.assetsUrl = `${environment.assetURL}`;
    this._tournamentService.getIpAddress(this.user_id).subscribe(data => {
      if (data.ip) this.ipAddress = data.ip;
    });
    this.addFundForm = this.formBuilder.group({
      selected_package: ['',Validators.required],
      custom_amt: ['', [Validators.pattern("^[0-9]{1,9}(\.[0-9][0-9])?$"),this.customAmountValidator()]],
      promo_code: [''],
      card_number: ['', [<any>CreditCardValidator.validateCCNumber]],
      name: ['', Validators.required],
      expiry: ['', [Validators.maxLength(7), <any>CreditCardValidator.validateExpDate]],
      cvv: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4)]],
      expiry_date: [''],
      postal_code : ['', [Validators.required,Validators.minLength(5), Validators.maxLength(10)]], 
    });
    this.addFunds();
  }

  getAmount(item: any) {
    this.addFundForm.controls['selected_package'].setValue(item.money);
    if(item !== 'other') {
        this.addFundForm.controls['custom_amt'].setValue(parseFloat(item.money));
    }else{
      this.addFundForm.controls['selected_package'].setValue('other');
      const match = this.fundsData.dataList.find(item =>parseFloat(item.money) == this.f.custom_amt.value);
      if(match){
        this.addFundForm.controls['selected_package'].setValue(match.money);
      }
    }
    if(this.f.promo_code.value && ((this.f.custom_amt.value && this.f.custom_amt.value > 0) || (this.f.selected_package.value != 'other' && this.f.selected_package.value)))  {
      this.isCheckPromoDis = false;
    }else{
      this.isCheckPromoDis = true;
      this.promo_code_validation.icon_color ='';
      this.promo_code_validation.message = '';
    }
    if (!this.isCheckPromoDis && this.f.promo_code.value && (this.f.selected_package.value !== 'other' || (this.f.custom_amt.value !== '' && this.f.custom_amt.value > 0))) {
      this.checkPromoCode("card");
    }
  }
  promoCodeDisable(){
     if(this.f.promo_code.value && ((this.f.custom_amt.value && this.f.custom_amt.value > 0) || (this.f.selected_package.value != 'other' && this.f.selected_package.value)))  {
      this.isCheckPromoDis = false;
    }else{
      this.isCheckPromoDis = true;
      this.promo_code_validation.icon ='';
      this.promo_code_validation.message = '';
    }
  }

  addFunds() {
    this.isFormShow = false;
    const userId = this.userData.id || 0;
    this.spinner.show();
    this._cardPaymentService.addFunds(userId).subscribe(data => {
      this.isFormShow = true;
      if (data.status === 'success') {
        this.fundsData = data.entities;
        if (this.fundsData.orderCount > 0 && this.fundsData.isDefault === 'Y') {
          this.promo_code_value = '';
        } else {
          this.promo_code_value = this.fundsData.promo_code;
          this.f['promo_code'].setValue(this.fundsData.promo_code);
        }
        if(this.welcomeDataObj && this.welcomeDataObj.status){
          const amount =  this.welcomeDataObj.amount;
          const match = this.fundsData.dataList.find(item => item.money == amount);
          if(match){
            this.getAmount({money:amount});
            this.f['selected_package'].setValue(amount);
          }else{
            this.f['custom_amt'].setValue(amount);
            this.getAmount('other');
          }
          this.f['promo_code'].setValue(this.welcomeDataObj.promoCode);
          if(this.welcomeDataObj.promoCode) this.isCheckPromoDis = false;
        }else{
          const amountVal = (this.fundsData && this.fundsData.dataList && this.fundsData.dataList[0] && this.fundsData.dataList[0].money) ? this.fundsData.dataList[0].money : this.selectedAmt;
           if(amountVal){
            this.f['custom_amt'].setValue(parseFloat(amountVal));
            this.getAmount('other');
          }
        }
      }
      this.spinner.hide();
    });
  }
  
  customAmountValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = Number(control.value);
      if (!value) return null;
      this.f.selected_package.setErrors({ required: false });
      if (value < this.minDeposit) {
        return { minDepositError: true };
      }
      if (value > this.maxDeposit) {
        return { maxDepositError: true };
      }
      return null;
    };
  }
 
  onSubmit() {
    this.submitted = true;
    if (this.f.custom_amt.value > 0) this.addFundForm.controls['selected_package'].setValue(this.f.selected_package.value);
    if( this.f.custom_amt.value == '' && (this.f.selected_package.value == '' || this.f.selected_package.value == 'other')){
      this.f.selected_package.setErrors({ required: true });
    }
   
    if (this.addFundForm.valid) {
      this.isDisable = true;
      const cardExpiryDate = this.f.expiry.value.replace(/ /gi, '');
      let fundData = {
        'user_id': this.user_id,
        'selected_package':  'other',
        'package_amount': this.f.custom_amt.value,
        'promo_code': this.f.promo_code.value,
        'currency': `${environment.CURRENCY_SYMBOL}`,
        'ip': this.ipAddress,
        'user_agent': this.deviceService.userAgent,
        'card_number': this.f.card_number.value,
        'name': this.f.name.value,
        'expiry': this.f.expiry.value,
        'expiry_date': cardExpiryDate,
        'cvv': this.f.cvv.value,
        'zip_code':this.f.postal_code.value
      };

      this.spinner.show();
      this._tournamentService.getUserLocation(this.user_id, locationData => {
        fundData['country'] = locationData['country'];
        fundData['state'] = locationData['state'];
        fundData['ip'] = locationData['ip'];
        fundData['user_dob'] = locationData['user_dob'];
        this._cardPaymentService.ftpCard(fundData).pipe(first()).subscribe(
          data => {
            if (data.status === 'success') {
              if (data.total_amount != null) {
                this.userData.dollar_balance = parseFloat(this.userData.dollar_balance) + parseFloat(data.total_amount);
                this.store.dispatch(new UserBalanceData(
                  this.userData.dollar_balance
                ));
              }
              let success_message = 'Your payment has been completed and amount added to your wallet.';
              if (data.message != null) success_message = data.message;
              this._flashMessagesService.show(success_message, { cssClass: 'alert-success', timeout: 10000, showCloseBtn: true });
              this.addFundForm.reset();
              this.depositSuccess.emit({status:true});
              this.promo_code_validation = { message: '', icon: 'far fa-check-circle', icon_color: '', validate: '',bonus_amount:'' };
              if(this.welcomeDataObj) this.dialogRef.close(data);
            } else {
              this.scrollToTop();
              this.depositSuccess.emit({status:false});
              this._flashMessagesService.show(data.errorMessage, { cssClass: 'alert-danger', timeout: 10000, showCloseBtn: true });
            }
            this.spinner.hide();
            this.submitted = false;
            this.isDisable = false; 
          },
          error => {
            this.spinner.hide();
            this.submitted = false;
            this.isDisable = false; 
            console.log(error);
          });
      });
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\.\ ]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  scrollToTop() {
    this.addFundFormElement.nativeElement.scrollTop = 0;
  }

  checkPromoCode(type) {
    if (type === 'card') {
      this.promo_code_validation.message = '';
      if (this.f.promo_code.value && (this.f.selected_package.value !== 'other' || (this.f.custom_amt.value !== '' && this.f.custom_amt.value > 2))) {
        this.isCheckingPromo = true;
        let data = { 'user_id': this.user_id, 'selected_package': "other", 'package_amount': this.f.custom_amt.value != 0 ? this.f.custom_amt.value : this.f.selected_package.value, 'promo_code': this.f.promo_code.value };
        this.sub_checkPromoCode = this._cardPaymentService.checkPromoCode(data).subscribe(res => {
          this.isCheckingPromo = false ;
          if (res.status === 'success') {
            this.promo_code_validation.message = res.msg;
            this.promo_code_validation.validate = res.validate;
            this.promo_code_validation.bonus_amount = res.bonus_amount;
            if (res.validate === 'yes') {
              this.promo_code_validation.icon = 'far fa-check-circle';
              this.promo_code_validation.icon_color = '#52a328';
            } else {
              this.promo_code_validation.icon = 'far fa-times-circle';
              this.promo_code_validation.icon_color = '#e8132e';
            }
          } else {
            this.scrollToTop();
            this.depositSuccess.emit({status:false});
            this.promo_code_validation.icon  = 'far fa-times-circle';
            this.promo_code_validation.icon_color  = '#e8132e';
            this.promo_code_validation.message = '';
            this._flashMessagesService.show(res.msg, { cssClass: 'alert-danger', timeout: 5000, showCloseBtn: true });
          }
        });
      } else if (((this.f.selected_package.value === '') && (this.f.custom_amt.value !== '' || this.f.custom_amt.value < 3))) {
        this.scrollToTop();
        this.depositSuccess.emit({status:false});
        this._flashMessagesService.show("The Charge amount field must contain a number greater than or equal to 3.", { cssClass: 'alert-danger', timeout: 5000, showCloseBtn: true });
      }
    } else {
      this.scrollToTop();
      this.depositSuccess.emit({status:false});
      this._flashMessagesService.show("Promo code is required.", { cssClass: 'alert-danger', timeout: 5000, showCloseBtn: true });
    }
  }
}
